import React from "react";
import feature from "../../../images/featureSvg.svg";
import { features } from "../../../data/HomeData";
import { BsArrowRightShort } from "react-icons/bs";
import { AiFillStar } from "react-icons/ai";
import user from "../../../images/user.png";
const Features = () => {
  return (
    <div className="p-10 space-y-5">
      <div className="space-y-4 w-3/5 ">
        <p className="text-sm text-primary font-semibold">Features</p>
        <h3 className="lg:text-3xl md:text-2xl text-xl text-black font-bold">
          A simple and easy mobile app
        </h3>
        <p className="text-accent ld:text-lg text-sm">
          Unlock anything with tap. Save your valuable time and reduce the
          hassle to rememtbering multiple passwords
        </p>
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-3">
        <div>
          {features.map((item, index) => (
            <div
              key={index}
              className="flex lg:flex-row md:flex-row flex-col  gap-1 items-start"
            >
              <img src={item.icon} alt="" />
              <div className="flex-col flex gap-3 p-2 ">
                <h3 className="lg:text-2xl text-xl font-bold">{item.title}</h3>
                <p className="text-accent ld:text-md text-sm">{item.text}</p>
                <a
                  href={item.link}
                  className="text-primary flex gap-1 items-center font-semibold"
                >
                  Learn More <BsArrowRightShort className="text-3xl" />
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center">
          <img src={feature} alt="" />
        </div>
      </div>
      <div className="lg:flex-row flex md:flex-row flex-col gap-2 justify-between bg-[#F9FFFC] py-16">
        <div className="lg:w-[22%] md:w-[22%]">
          <img src={user} alt="" className="w-full " />
        </div>
        <div className="space-y-3 w-[70%]">
          <div className="flex items-center text-warning">
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
          </div>
          <h3 className="text-2xl font-semibold text-black">
            Knoct has been a life saver for our team. We work with numberous
            softwares, tools and websites, having the power to login with a
            touch saves our team hours in time in managing and remembering
            credentials.
          </h3>
          <div>
            <p className="text-lg font-semibold text-black mb-1">Nirdesh Dwa</p>
            <p className="text-accent text-sm">CEO, veda-app.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
